import React, { useState } from 'react';
import Modal from 'react-modal';
import PopUpSurveyForm from './PopUpSurveyForm';
import useFeedbackModal from './hooks/useFeedbackModal';

// id for website template
// const defaultTempId = '6aec15f7-f46e-4bca-8328-d8294a82679b';

const PopUpSurvey = ({
  siteFormat,
  popUpSurveyOpen,
  handleOpenFeedbackModal,
  store,
  isStoreFeedback,
  triggerPushSurvey,
  handleGeneralFeedback,
}) => {
  const {
    hover,
    selectedState,
    selectedTemplate,
    loading,
    error,
    errorMessage,
    submitSuccess,
    attemptedSubmit,
    answersObj,
    handleInput,
    handleSelectYoN,
    handleResetPushSurveyModal,
    handleHover,
    handleSelectState,
    handleSubmitFeedback,
  } = useFeedbackModal(
    handleOpenFeedbackModal,
    store,
    isStoreFeedback,
    triggerPushSurvey,
    handleGeneralFeedback,
    popUpSurveyOpen
  );

  const [showInviteView, setShowInviteView] = useState(true);

  const handleInviteResponse = () => {
    setShowInviteView(false);
  };

  return (
    <div>
      <Modal
        portalClassName={'ReactModalPortal dds'}
        id='feedback_modal'
        className='QvModal__Content ReactModal__KeepOpenFor_OSS feedback_modal'
        overlayClassName='QvModal__Overlay ReactModal__KeepOpenFor_OSS'
        isOpen={popUpSurveyOpen}
      >
        <PopUpSurveyForm
          showInviteView={showInviteView}
          handleInviteResponse={handleInviteResponse}
          handleResetModal={handleResetPushSurveyModal}
          handleHover={handleHover}
          hover={hover}
          selectedTemplate={selectedTemplate}
          selectedState={selectedState}
          handleSelectState={handleSelectState}
          loading={loading}
          error={error}
          errorMessage={errorMessage}
          handleSubmitFeedback={handleSubmitFeedback}
          handleInput={handleInput}
          handleSelectYoN={handleSelectYoN}
          submitSuccess={submitSuccess}
          attemptedSubmit={attemptedSubmit}
          siteFormat={siteFormat}
          answersObj={answersObj}
        />
      </Modal>
    </div>
  );
};

export default PopUpSurvey;
